<div class="search-group-items">
  <div class="search-group-items-text">
    {{ label }}
    <span class="items-text-coment">{{ subText }}</span>
  </div>
  <div class="large"><ng-content></ng-content></div>
  <div class="error">{{ errorMessage }}</div>
</div>
